{
  "instances": {
    "caches": {
      "label": "Caches",
      "cache_manager": "Cache Manager",
      "loading_caches": "Cache-Informationen werden geladen...",
      "name": "Name",
      "no_caches_found": "Keine Cache-Informationen gefunden."
    }
  }
}
